/**
 * next/navigation shim over the custom history router (../router). Read-only
 * where the app reads (usePathname/useSearchParams sync on raw history calls,
 * matching Next's interop) and imperative where it navigates.
 */
import { useAppLocation, navigate, useParamsValue } from "../router";

export function usePathname(): string {
  return useAppLocation().pathname;
}

export function useSearchParams(): URLSearchParams {
  return new URLSearchParams(useAppLocation().search);
}

export function useParams(): Record<string, string> {
  return useParamsValue();
}

export function useRouter() {
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => window.history.back(),
    prefetch: (_href: string) => {}, // nothing to prefetch — the SPA IS the bundle
    refresh: () => {},
  };
}

export function redirect(href: string): never {
  navigate(href, { replace: true });
  throw new Error("NEXT_REDIRECT(shim)"); // matches Next's throw-on-redirect contract
}
